import styled from 'styled-components';

export const Container = styled.div`
  width: ${(props) => (props.$isOpen ? '240px' : '48px')};
  flex-shrink: 0;
  border-right: 1px solid ${(props) => props.theme.colors.dividerGray};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.25s ease;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$isOpen ? 'space-between' : 'center')};
  padding: ${(props) => (props.$isOpen ? '24px 20px 16px' : '16px 0')};
  flex-shrink: 0;
`;

export const Title = styled.div`
  overflow: hidden;
  white-space: nowrap;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: opacity 0.15s ease;
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
`;

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: opacity 0.15s ease;
  pointer-events: ${(props) => (props.$isOpen ? 'auto' : 'none')};
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  cursor: pointer;
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: ${(props) => (props.$active ? 600 : 400)};
  color: ${(props) => (props.$active ? props.theme.colors.celticBlue : props.theme.colors.davysGrey)};
  background: ${(props) => (props.$active ? props.theme.colors.aliceBlue : 'transparent')};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${(props) => (props.$active ? props.theme.colors.aliceBlue : props.theme.colors.ghostWhite)};
  }
`;
